<template>
  <div class="Filters">
    <div class="Section" v-if="filterOptions">
      <div class="Filters__header">
        Filtres
        <div class="Filters__valid-link" @click="$emit('submitFilters')">
          <IconBase iconName="check"><IconCheck /></IconBase>
        </div>
      </div>
      <section class="Filters__section">
        <label class="Filters__label" for="">Couleur</label>
        <div class="Filters__colors">
          <ColorFilter
            @toggleColor="toggleColor"
            class="Filters__color"
            v-for="color in filterOptions.colors"
            :key="color"
            :color="color"
            :isActive="isColorActive(color)"
          />
        </div>

      </section>

      <section class="Filters__section">
        <SwitchInput id="bio" label="UNIQUEMENT BIOLOGIQUE" v-model="only_bio" />
      </section>

      <section class="Filters__section">
        <label class="Filters__label" for="">Format</label>
        <select class="Select" v-model="capacity">
          <option></option>
          <option v-for="c in filterOptions.capacities" :key="c.slug" :value="c.slug">{{ c.name + "-" +c.capacity }}</option>
        </select>

      </section>
      <section class="Filters__section">
        <label class="Filters__label" for="">Fourchette de prix</label>
        <div class="Filters__prices">
          <div class="InputGroup InputGroup--secondary InputGroup--small Filters__price">
            <Input v-model="min_price" type="number" placeholder="Min" step="1" />
          </div>
          <div class="InputGroup InputGroup--secondary InputGroup--small Filters__price">
            <Input v-model="max_price" type="number" placeholder="Max" step="1" />
          </div>
        </div>

      </section>

      <section class="Filters__section">
        <label class="Filters__label" for="">Millésime</label>
        <Multiselect :options="filterOptions.years" :value="filters.years" @input="setYears" placeholder="Ajouter une année" />
      </section>

      <section class="Filters__section">
        <label class="Filters__label" for="">Région</label>
        <Multiselect :options="filterOptions.families" :value="filters.families" @input="setFamilies" placeholder="Ajouter une région" />
      </section>
    </div>

  </div>
</template>

<script>

import { mapState, mapMutations } from "vuex";
import SwitchInput from "./SwitchInput";
import ColorFilter from "./ColorFilter";
import Multiselect from "./Multiselect";
import Input from "./Input";
import IconCheck from "./icons/IconCheck";

export default {
  computed: {
    ...mapState("search", ["filterOptions", "filters"]),

    capacity: {
      get() {
        return this.filters.capacity;
      },
      set(value) {
        this.setCapacity(value);
      }
    },
    only_bio: {
      get() {
        return this.filters.only_bio && parseInt(this.filters.only_bio) === 1;
      },
      set(value) {
        this.setOnlyBio(value);
      }
    },
    "min_price": {
      get() {
        return this.filters.min_price ? (this.filters.min_price / 100).toString() : null;
      },
      set(value) {
        this.setMinPrice(value);
      }
    },
    "max_price": {
      get() {
        return this.filters.max_price ? (this.filters.max_price / 100).toString() : null;
      },
      set(value) {
        this.setMaxPrice(value);
      }
    }
  },
  methods: {
    isColorActive(color) {
      return this.filters.colors && this.filters.colors.includes(color);
    },
    ...mapMutations("search", ["setYears", "setMaxPrice", "setFamilies", "setMinPrice", "setCapacity", "toggleColor", "setOnlyBio"])
  },

  components: {
    ColorFilter,
    Multiselect,
    IconCheck,
    Input,
    SwitchInput
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.Filters {
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 22rem;
  padding: 0.5rem;
  display: flex;
  flex-flow: column;
  background: $color-primary;
  color: #fff;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
  overflow: auto;

  &__valid-link {
    cursor: pointer;
  }

  &__header {
    padding: $global-margin 0;
    margin-bottom: $global-margin;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.3125rem;
    font-weight: 600;
  }

  &__section {
    margin-bottom: $global-margin * 2;
  }

  &__label {
    margin-bottom: $global-margin;
    display: block;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 0.75rem;
  }

  &__prices {
    display: flex;
    justify-content: space-between;
  }

  &__price {
    width: calc(50% - #{$global-margin});
  }

  &__colors {
    display: flex;
    align-items: center;
  }

  &__color {
    margin-right: $global-margin;
  }
}
</style>
